import Model from "../Model";

export interface TRegisteredApplicant {
  id: number;
  partyId: string;
  personalID: string;
  firstName: string;
  lastName: string;
  placeOfBirth: string;
  name: string;
  description: string;
  fatherName: string;
  motherSurname: string;
  username: string;
  phoneNumber?: string;
  address?: string;
  email?: string;
}

export interface IRegisteredApplicant extends TRegisteredApplicant {}

const RegisteredApplicant = Model(
  (model: TRegisteredApplicant): IRegisteredApplicant => {
    const _applicant: TRegisteredApplicant = Object.assign({}, model);

    return {
      get id() {
        return _applicant.id;
      },

      get partyId() {
        return _applicant.partyId;
      },

      get personalID() {
        return _applicant.personalID;
      },

      get firstName() {
        return _applicant.firstName;
      },

      get lastName() {
        return _applicant.lastName;
      },

      get placeOfBirth() {
        return _applicant.placeOfBirth;
      },

      get name() {
        return `${_applicant.firstName} ${_applicant.lastName}`;
      },

      get description() {
        return _applicant.description;
      },

      get fatherName() {
        return _applicant.fatherName;
      },

      get motherSurname() {
        return _applicant.motherSurname;
      },

      get username() {
        return _applicant.username;
      },

      get phoneNumber() {
        return _applicant.phoneNumber;
      },

      get address() {
        return _applicant.address;
      },

      get email() {
        return _applicant.email;
      }
    };
  }
);

export default RegisteredApplicant;
